import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
const slides = [{
  id: 1,
  image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1920&q=80',
  title: 'Building Excellence in Commercial Construction',
  subtitle: 'Setting the standard for quality and innovation in every project.'
}, {
  id: 2,
  image: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=1920&q=80',
  title: 'Engineering Solutions You Can Trust',
  subtitle: 'Expertise that stands the test of time.'
}, {
  id: 3,
  image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=1920&q=80',
  title: 'From Blueprint to Reality',
  subtitle: 'Turning your vision into tangible structures.'
}, {
  id: 4,
  image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=1920&q=80',
  title: 'Decades of Proven Results',
  subtitle: 'A legacy of success in the commercial sector.'
}];
export function HeroSlideshow() {
  const [current, setCurrent] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent(prev => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);
  return <div className="relative h-screen w-full overflow-hidden bg-black" data-id="element-67" data-mp="fkeuluemx83d">
      <AnimatePresence mode="wait" data-id="element-68" data-mp="1l5f6wy96i0g">
        <motion.div key={current} initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 1
      }} className="absolute inset-0" data-id="element-69" data-mp="1p2ypjoqtbkv">
          {/* Background Image */}
          <div className="absolute inset-0 bg-cover bg-center" style={{
          backgroundImage: `url(${slides[current].image})`
        }} data-id="element-70" data-mp="1m33coe6rzaen" />
          {/* Overlay */}
          <div className="absolute inset-0 bg-black/60" data-id="element-71" data-mp="1plsrnbm3ejl9" />

          {/* Content */}
          <div className="absolute inset-0 flex items-start justify-center pt-[15vh]" data-id="element-72" data-mp="1kjtl5sv236k3">
            <div className="max-w-7xl mx-auto px-4 md:px-8 w-full text-center" data-id="element-73" data-mp="1fn35v7r2sezq">
              <motion.img src="https://cdn.magicpatterns.com/uploads/dpR9DXwCEF7xE6YLwrKxu9/1-offical-logo.png" alt="Sinclair Development" initial={{
              scale: 0.8,
              opacity: 0
            }} animate={{
              scale: 1,
              opacity: 1
            }} transition={{
              delay: 0.3,
              duration: 0.8
            }} className="h-28 md:h-36 w-auto mx-auto mb-8 border-2 border-white rounded-sm bg-black p-4" data-id="element-74" data-mp="1blhyg1xb8swx" />
              <motion.h1 initial={{
              y: 30,
              opacity: 0
            }} animate={{
              y: 0,
              opacity: 1
            }} transition={{
              delay: 0.5,
              duration: 0.8
            }} className="text-4xl md:text-6xl lg:text-7xl font-bold font-serif text-white mb-6 leading-tight" data-id="element-75" data-mp="2m9p6oc1vt6ud">
                {slides[current].title}
              </motion.h1>
              <motion.p initial={{
              y: 30,
              opacity: 0
            }} animate={{
              y: 0,
              opacity: 1
            }} transition={{
              delay: 0.7,
              duration: 0.8
            }} className="text-lg md:text-2xl text-gray-200 mb-10 max-w-3xl mx-auto font-light" data-id="element-76" data-mp="rovtc6kyr8hm">
                {slides[current].subtitle}
              </motion.p>
              <motion.div initial={{
              y: 30,
              opacity: 0
            }} animate={{
              y: 0,
              opacity: 1
            }} transition={{
              delay: 0.9,
              duration: 0.8
            }} data-id="element-77" data-mp="11tu2eft3h7is">
                <Link to="/contact" className="inline-flex items-center gap-2 bg-[#C5A55A] hover:bg-[#D4AF37] text-black px-8 py-4 text-lg font-medium rounded-sm transition-all duration-300 transform hover:scale-105" data-id="element-78" data-mp="16lvdvzifuu7r">
                  Start Your Project
                  <ArrowRight className="w-5 h-5" data-id="element-79" data-mp="suqft1upy9zj" />
                </Link>
              </motion.div>
            </div>
          </div>
        </motion.div>
      </AnimatePresence>

      {/* Indicators */}
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 flex gap-3 z-20" data-id="element-80" data-mp="246hjn7leahgg">
        {slides.map((_, index) => <button key={index} onClick={() => setCurrent(index)} className={`w-3 h-3 rounded-full transition-all duration-300 ${index === current ? 'bg-[#C5A55A] w-8' : 'bg-white/50 hover:bg-white'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-81" data-mp="26sqowvgm3nh1" data-mpi={index} />)}
      </div>
    </div>;
}